import { Injectable } from '@angular/core';
import { Router, ActivatedRoute } from "@angular/router";
import { SharedService } from './shared.service';

@Injectable({
    providedIn: 'root'
})
export class GlobalService {

    public globalQueryParams: any;

    constructor(private readonly sharedService: SharedService, private readonly router: Router, private readonly route: ActivatedRoute) { }

    public getQueryParamsAndSaveToVariable(queryparams: any) {
        this.globalQueryParams = queryparams;
    }

    /** Generates the Panelist Payload for panelist_user_choices and panelist_profiling Collection
    * @param {*Object choiceObj - either choice key or piiFormDetails key will be sent
    * @param {*boolean terminate
    * @returns {Array} - Array of two Panelist Payload objects
    */
    public createPanelistPayload = (choiceObj: any, terminate: any) => {
        const panelistUserObj = {
            ...choiceObj,
            grp_id: Number.parseInt(this.sharedService.rootData.grp_id),
            PID: this.sharedService.rootData.PID,
            supCode: this.sharedService.rootData.supCode,
            uid: this.sharedService.rootData.uid,
            isTerminate: terminate,
            cnt: this.sharedService.rootData.countryCode,
            lang: this.globalQueryParams?.Lang?.toUpperCase() || "ENGLISH",
            deviceId: this.sharedService.rootData.RVID
        };
        const panelistProfileObj = {
            ...choiceObj,
            PID: this.sharedService.rootData.PID,
            supCode: this.sharedService.rootData.supCode,
            grp_id: Number.parseInt(this.sharedService.rootData.grp_id),
            uid: this.sharedService.rootData.uid,
            cnt: this.sharedService.rootData.countryCode,
            lang: this.globalQueryParams?.Lang?.toUpperCase() || "ENGLISH"
        };
        return [panelistUserObj, panelistProfileObj];
    };

    /**
      * For call fetchGroupDetails
      */
    public fetchGroupDetails(grpId: any) {
        return new Promise((resolve, reject) => {
            if (!grpId
                || this.sharedService.rootData.grp_id === this.sharedService.rootData.currentGrpId) {
                return resolve(null);
            }
                this.sharedService.getGrpDetails(this.sharedService.rootData.grp_id, this.sharedService.rootData.oeQues)
                    .subscribe({
                        next: (group: any) => {
                            this.sharedService.rootData.currentGrpId = this.sharedService.rootData.grp_id;
                            this.sharedService.rootData.group = group.grpDetail;
                            this.sharedService.rootData.isPega = group.grpDetail.isPega;
                            if (!!this.sharedService.rootData.isOEValidation && !!this.sharedService.rootData.oeThresholdLevel) {
                                return resolve(null);
                            }
                                this.sharedService.getJobDetails(group.grpDetail.jb_id)
                                    .subscribe({
                                        next: (jobObj: any) => {
                                            this.sharedService.rootData.jb_id = jobObj.job.id;
                                            this.sharedService.rootData.jobDetailsObj = jobObj.job;
                                            const supCode = this.sharedService.rootData.supCode;
                                            if (
                                                supCode === null ||
                                                supCode === '' ||
                                                (typeof supCode === 'number' && Number.isNaN(supCode))
                                            ) {
                                                return resolve(null);
                                            }
                                                this.sharedService.getSuplierByCondition(this.sharedService.rootData.supCode)
                                                    .subscribe({
                                                        next: (data: any) => {
                                                            this.sharedService.rootData.isOEValidation = jobObj.job.chkOeValid ? (data?.result?.dsblTA) ? 0 : 1 : 0;
                                                            this.sharedService.rootData.oeThreshLev = jobObj.job.oeThreshLev;
                                                            // APICC-70 Fetch oeThreshold level from supplier level, on the basis of country code, group type, supplier code basis
                                                            if (!this.sharedService.rootData.isOEValidation) {
                                                                return resolve(null);
                                                            }
                                                                const obj = {
                                                                    supId: this.sharedService.rootData.supCode,
                                                                    cnt: this.sharedService.rootData.countryCode,
                                                                    grpTp: this.sharedService.rootData.group.grp_typ
                                                                }
                                                                this.sharedService.getOeThresholdFromSupplier(obj)
                                                                    .subscribe({
                                                                        next: (result: any) => {
                                                                            this.sharedService.rootData.oeThreshLev =
                                                                                result?.supplierOeThreshLev
                                                                                    ? result.supplierOeThreshLev
                                                                                    : jobObj.job.oeThreshLev;
                                                                            resolve(null);
                                                                        },
                                                                        error: (err: any) => {
                                                                            console.error(`ERROR in getOeThresholdFromSupplier:${JSON.stringify(err)}`);
                                                                            resolve(null);
                                                                        }
                                                                    });
                                                            /*} else {
                                                                resolve(null);
                                                            }*/
                                                        },
                                                        error: (err: any) => {
                                                            console.error(`ERROR in getSuplierByCondition:${JSON.stringify(err)}`);
                                                            resolve(null);
                                                        }
                                                    });
                                            /*} else {
                                                resolve(null);
                                            }*/
                                        },
                                        error: (err: any) => {
                                            console.error(`ERROR in getJobDetails:${JSON.stringify(err)}`);
                                            resolve(null);
                                        }
                                    });
                            /*} else {
                                resolve(null);
                            }*/
                        },
                        error: (err: any) => {
                            console.error(`ERROR in getGroupDetails:${JSON.stringify(err)}`);
                            resolve(null);
                        }
                    });
            /*} else {
                resolve(null);
            }*/
        });
    }

    //Function to add/update panelist profiling in panelist_profile collection
    //Here we also setup rating scale and terminate/allowed the repondent based on rating scale if same respondent comes with same supplier.
    public updatePanelistProfiling(payload: any) {
        if (!this.sharedService.rootData.Test) {
            this.sharedService.updateAllPanelistProfile(payload)
                .subscribe({
                    next: (data: any) => {
                    },
                    error: (error: any) => {}
                });
        } else {
            console.info("updatePanelistProfiling: Panelist Profile will not stored for test survey");
        }
    }

    // Function to syncing data instantly as user completes all profiling questions.
    public syncProfilingQus() {
        this.sharedService.syncProfilingQusWithPc(Number.parseInt(this.sharedService.rootData.grp_id), this.sharedService.rootData.PID, this.sharedService.rootData.supCode, this.sharedService.rootData.uid).subscribe({
            next: (data: any) => {
            },
            error: (error) => {
                console.error(`ERROR in syncProfilingQusWithPc ${JSON.stringify(error)} ${JSON.stringify(this.sharedService.rootData)}`);
            }
        });
    }

}
